export class CancellationsReportData {

    constructor(
        public bookingId: string,
        public firstName: string | null,
        public lastName: string | null,
        public emailAddress: string | null,
        public partySize: number,
        public bookingStart: Date,
        public cancelledAt: Date,
        public cancellationReasonId: string | null,
        public cancellationReasonDisplayName: string | null
    ) { }

    get name(): string {
        return [this.firstName, this.lastName]
            .map(name => name?.trim())
            .filter((name): name is string => !!name)
            .join(' ')
    }
}
